<template>
  <div class="animated fadeIn">
    <div id="fb-root-container">
      <div id="fb-root"></div>
    </div>
    <b-row id='dashboardHeader'>
      <b-col sm="4">
        <b-card border-variant="danger"
            header="Youtube"
            header-bg-variant="danger"
            header-text-variant="white"
            align="center">
            <div id="youtubeChartdiv" class="CSSAnimationChart"></div>
        </b-card>
      </b-col>
      <b-col sm="4">
        <b-card border-variant="primary"
            header="Facebook"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center">
            <div id="facebookChartdiv" class="CSSAnimationChart"></div>
        </b-card>
      </b-col>
      <b-col sm="4">
        <b-card border-variant="secondary"
            header="SMR"
            header-bg-variant="secondary"
            header-text-variant="white"
            align="center">
            <div id="smrChartdiv" class="CSSAnimationChart"></div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <a href="http://nextvip.feeldmc.com/index" target=_blank>
          <img src="static/img/banner/banner_01.jpg" height="100%" width="100%">
        </a>
      </b-col>
      <b-col sm="6">
        <a href="https://www.dmcreport.co.kr/#/ReportRedirecting?p_code=DMCARP20190014" target=_blank>
          <img src="static/img/banner/banner_05.jpg" height="100%" width="100%">
        </a>
      </b-col>
    </b-row>
    <b-row style="padding-top:25px;">
      <b-col sm="9">
        <b-row>
          <b-col sm="6">
            <b-card style="height:460px;">
                <Notice ></Notice>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card style="height:460px;">
                <FreeBoard ></FreeBoard>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="3">
        <b-card style="height:460px;">
          <FBPage ref="fbPageRef"></FBPage>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import reachFormData from "../common/ReachFormData.js";
import reachLogic from "../common/ReachLogic.js";
import leftSideUtil from "../common/LeftSideUtil.js" // 타겟 선택 컴포넌트
import modelFormData from "../common/ModelFormData.js";
import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import youtubeChart from "./youtubeChart.js";
import facebookChart from "./facebookChart.js";
import smrChart from "./smrChart.js";
import Notice from "./Notice";
import FreeBoard from "./FreeBoard";
import FBPage from "./FBPage";

import Vue from 'vue';
// Vue.http.headers.common['Access-Control-Allow-Origin'] = 'https://www.facebook.com';

export default {
  name: 'dashboard',
  components: {
    Notice : Notice,
    FreeBoard : FreeBoard,
    FBPage : FBPage
  },
  data: function () {
    return {
      selected: 'Month',
      componentsList : [],
      screens: modelFormData.ScreenMediaStructure,
    }
  },
  created: function(){
    // if(sessionStorage.getItem("dashBoardReload") == 'true'){
    //   console.log('sessionStorage.getItem("dashBoardReload") : ' + sessionStorage.getItem("dashBoardReload"));
    //   sessionStorage.setItem("dashBoardReload", 'false');
    //   location.reload();
    // }
  },
  updated: function(){
  },
  mounted: function() {
    this.getScreenChannel('VA', 'TV');
    this.getScreenChannel('VA', 'PC');
    this.getScreenChannel('VA', 'Mobile');
    this.getScreenChannel('VA', 'Digital');
    this.getScreenChannel('DA', 'Digital')
    this.getScreenChannel('DA', 'PC');
    this.getScreenChannel('DA', 'Mobile');
    // 모수가 세션에 저장되기 전에 reachTarget.vue 가 실행되면 종종 에러가 발생하여서
    // 대쉬보드화면에 모수를 세션에 저장하는 로직을 추가 18.12.26
    this.$http.get('/select/demographics')
      .then((result) => {
        this.$session.set('demographics', result.data);
    })
    leftSideUtil.highLightMenu('mainCustomId8642');

    this.makeYoutubeChart();
    this.makeFacebookChart();
    this.makeSMRChart();
  },
  methods: {
    getScreenChannel(type, media) {
      var user_id = this.$session.get('email');
      this.$http.get('/select/screenchannel?type=' + type + '&media=' + media)
        .then((result) => {
          for(var i=0; i<result.data.length; i++){
              this.screens[type][media][result.data[i].channel] = [];
              this.$http.get('/select/screenvehicle?type=' + type + '&media=' + media + '&channel=' + result.data[i].channel+ '&user_id='+user_id)
                .then((resultV) => {
                  this.screens[type][media][resultV.data[0].channel] = resultV.data;
              })
          }
        })
    },
    makeYoutubeChart(){
      var mediaList = [];
      var mediaInfo = this.$_.clone(reachFormData.mediaInfo);
      mediaInfo.media = "Digital";
      mediaInfo.channel = "Youtube";
      mediaInfo.vehicle ="전체";
      mediaInfo.target ="MF769";
      mediaList.push(mediaInfo);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(mediaList));

      this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
        .then((result) => {
          var resultList = this.makeResultList(result.data[0], 800);
          youtubeChart.drawChart(resultList);
      });
    },
    makeFacebookChart(){
      var mediaList = [];
      var mediaInfo = this.$_.clone(reachFormData.mediaInfo);
      mediaInfo.media = "Digital";
      mediaInfo.channel = "Facebook";
      mediaInfo.vehicle ="전체";
      mediaInfo.target ="MF769";
      mediaList.push(mediaInfo);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(mediaList));

      this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
        .then((result) => {
          var resultList = this.makeResultList(result.data[0], 800);
          facebookChart.drawChart(resultList);
      });
    },
    makeSMRChart(){
      var mediaList = [];
      var mediaInfo = this.$_.clone(reachFormData.mediaInfo);
      mediaInfo.media = "Digital";
      mediaInfo.channel = "SMR";
      mediaInfo.vehicle ="전체";
      mediaInfo.target ="MF769";
      mediaList.push(mediaInfo);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(mediaList));

      this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
        .then((result) => {
          var resultList = this.makeResultList(result.data[0], 800);
          smrChart.drawChart(resultList);
      });
    },
    makeResultList(resultData, max){
      var resultList = [];

      for(var i=0 ;i<max; i++){
        var reach1Result = { reach1:0, grps:0};
        reach1Result.reach1 = reachLogic.rgpReachCalc(resultData, i).toFixed(2);
        reach1Result.grps = i;
        resultList.push(reach1Result);
      }
      return resultList;
    },
  }
}
</script>
<style src="../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
#dashboardHeader
  .card-header{
    font-size: 28px;
    font-weight: 800;
}
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 300px
}
.card-header {
    height: 50px;
    padding: 0rem 0rem;
}
.hidden_header {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue